const $inject = [];

const lbaTabs = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaTabsCtrl',
    controllerAs: 'vm',
    template: require('./lbaTabs.html')
  }
};

lbaTabs.$inject = $inject;

export default lbaTabs;



// WEBPACK FOOTER //
// ./src/components/lbaTabs/lbaTabsDir.js